function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import customerCareKeys from '../../../../../locales/keys';
import { CurrentAccountSummarySelector, ConvergentBillerCurrentPromiseToPayInstallment, ConvergentBillerIsInPromiseToPay, IsFetchingSubscriberSummarySelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { retrieveConvergentBillerTreatmentDetails } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../../../reducers/selectors/customer.selectors';
import { PermissionService } from 'invision-core';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { SUBSCRIBER_TREATMENT_ACCESS } from '../../../../../security.attributes';
var TreatmentController = /*#__PURE__*/function () {
  function TreatmentController($ngRedux) {
    var _this = this;
    _classCallCheck(this, TreatmentController);
    _defineProperty(this, "hasTreatmentReadAccess", function () {
      return PermissionService.hasAccess(_this.state.userSecurityAttributes, SUBSCRIBER_TREATMENT_ACCESS);
    });
    Object.assign(this, {
      $ngRedux: $ngRedux,
      customerCareKeys: customerCareKeys,
      hasTreatmentReadAccess: this.hasTreatmentReadAccess.bind(this)
    });
  }
  return _createClass(TreatmentController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        retrieveConvergentBillerTreatmentDetails: retrieveConvergentBillerTreatmentDetails
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          accountSummary: CurrentAccountSummarySelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPromiseToPayInstallment: ConvergentBillerCurrentPromiseToPayInstallment(store),
          hasPromiseToPay: ConvergentBillerIsInPromiseToPay(store),
          isFetchingAccountSummary: IsFetchingSubscriberSummarySelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      if (this.state.hasPromiseToPay) {
        this.actions.retrieveConvergentBillerTreatmentDetails(this.state.currentCustomerId);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./treatment.html'),
  controller: TreatmentController,
  controllerAs: 'Treatment'
};